import { Button, HStack, Portal, Text } from "@chakra-ui/react";
import type { CSSProperties, PropsWithChildren, ReactNode } from "react";
import FiltersIcon from "../src/assets/icons/tune.svg?react";
import {
    PopoverArrow,
    PopoverBody,
    PopoverCloseTrigger,
    PopoverContent,
    PopoverFooter,
    PopoverRoot,
    PopoverTrigger,
} from "./components/ui/popover";

export interface PopoverComboProps {
    triggerLabel?: string;
    renderTrigger?: (triggerProps: { label?: string }) => ReactNode;
    header?: ReactNode;
    footer?: ReactNode;
    closeOnBlur?: boolean;
    isOpen?: boolean;
    showArrow?: boolean;
    onOpen?: () => void;
    onClose?: () => void;
    styles?: {
        trigger?: CSSProperties;
        content?: CSSProperties;
        body?: CSSProperties;
        header?: CSSProperties;
        footer?: CSSProperties;
    };
}

export default function PopoverCombo(p: PropsWithChildren<PopoverComboProps>) {
    const renderTrigger = p.renderTrigger ?? defaultRenderTrigger;
    const showArrow = p.showArrow ?? true;
    return (
        <PopoverRoot
            closeOnEscape={p.closeOnBlur}
            closeOnInteractOutside={p.closeOnBlur}
            open={p.isOpen}
            onOpenChange={e => (e.open ? p.onOpen?.() : p.onClose?.())} // need to verify this
            // modifiers={[     //need to find alternative
            //     {
            //         name: "preventOverflow",
            //         options: {
            //             boundary: "viewport",
            //             padding: 16,
            //         },
            //     },
            // ]}
        >
            <PopoverTrigger asChild style={p.styles?.trigger}>
                {renderTrigger({
                    label: p.triggerLabel,
                })}
            </PopoverTrigger>
            <Portal>
                <PopoverContent
                    style={{
                        ...p.styles?.content,
                    }}
                >
                    {showArrow && <PopoverArrow />}
                    {p.header && (
                        <HStack
                            borderBottomWidth={"1px"}
                            alignItems={"center"}
                            p={5}
                        >
                            <FiltersIcon />
                            <Text
                                fontSize={"md"}
                                fontWeight={"bold"}
                                style={p.styles?.header}
                            >
                                {p.header}
                            </Text>
                        </HStack>
                    )}
                    <PopoverBody style={p.styles?.body}>
                        {p.children}
                    </PopoverBody>
                    {p.footer && (
                        <PopoverFooter style={p.styles?.footer}>
                            {p.footer}
                        </PopoverFooter>
                    )}
                    <PopoverCloseTrigger zIndex={900} margin={"8px"} />
                </PopoverContent>
            </Portal>
        </PopoverRoot>
    );
}

const defaultRenderTrigger = (p: { label?: string }) => (
    <Button size="sm">{p.label ?? "Open"}</Button>
);
